/*
 * Olfactory pyramid normaliser.
 *
 * Product descriptions in this catalogue spell the pyramid four different ways:
 *   A  <p>Testa<br>Zafferano<br>Lampone</p>
 *   B  <ul><li>Testa: zafferano, caffè tostato</li></ul>
 *   C  <p><strong>TESTA</strong></p><p>Pesca</p><p>Tangerino</p>
 *   D  <p><strong>TESTA :</strong> Frutti rossi, zafferano</p>
 * This rewrites all four into one bulleted three-tier block. Anything it does
 * not confidently recognise is left exactly as the merchant wrote it.
 */
(function () {
  var TIERS = ['testa', 'cuore', 'fondo'];
  var PREFIX = '(?:note\\s+(?:di\\s+)?)?';
  var SEP = '[:.\u2013\u2014\\-]';
  var LABEL_ONLY = new RegExp('^' + PREFIX + '(testa|cuore|fondo)\\s*' + SEP + '?$', 'i');
  var LABEL_INLINE = new RegExp('^' + PREFIX + '(testa|cuore|fondo)\\s*(?:' + SEP + '\\s*|\\s+)(.+)$', 'i');
  var PYRAMID_TITLE = /^(piramide\s+olfattiva|note\s+olfattive)\s*:?$/i;
  var MAX_WORDS_PER_NOTE = 6;

  function clean(s) {
    return s.replace(/ /g, ' ').replace(/\s+/g, ' ')
            .replace(/^[\s,;.:·•\-–—]+/, '')
            .replace(/[\s,;.:·•\-–—]+$/, '').trim();
  }
  function words(s) { return s.split(' ').filter(Boolean).length; }

  function splitNotes(text) {
    var parts = text.split(/[,;\/\u00b7\u2022]+/).map(clean).filter(Boolean);
    for (var i = 0; i < parts.length; i++) {
      if (words(parts[i]) > MAX_WORDS_PER_NOTE) return null; // prose, not notes
    }
    return parts.length ? parts : null;
  }

  /* Break one element into the text segments it carries. */
  function segmentsOf(el) {
    if (el.tagName === 'UL' || el.tagName === 'OL') {
      return Array.prototype.map.call(el.children, function (li) { return clean(li.textContent); });
    }
    if (el.querySelector('br')) {
      var html = el.innerHTML.split(/<br\s*\/?>/i);
      var tmp = document.createElement('div');
      return html.map(function (chunk) { tmp.innerHTML = chunk; return clean(tmp.textContent); });
    }
    return [clean(el.textContent)];
  }

  /* Some descriptions wrap everything in a styled <div>. */
  function unwrap(root) {
    var guard = 0;
    while (guard++ < 4) {
      var kids = Array.prototype.filter.call(root.children, function (el) { return el.nodeType === 1; });
      if (kids.length === 1 && /^(DIV|SECTION|ARTICLE)$/.test(kids[0].tagName)) { root = kids[0]; continue; }
      break;
    }
    return root;
  }

  /* Rows of a Word-pasted table: "Note di Testa | Crema di Latte, Fragola". */
  function parseTable(table) {
    var found = [];
    Array.prototype.forEach.call(table.querySelectorAll('tr'), function (tr) {
      var cells = tr.children;
      if (cells.length < 2) return;
      var label = clean(cells[0].textContent).match(LABEL_ONLY);
      if (!label) return;
      var notes = splitNotes(clean(cells[1].textContent));
      if (notes) found.push({ key: label[1].toLowerCase(), notes: notes });
    });
    return found;
  }

  function parse(root) {
    root = unwrap(root);
    var children = Array.prototype.filter.call(root.children, function (el) {
      return el.nodeType === 1;
    });
    var tiers = [];
    var consumed = [];
    var open = null;      // tier still accepting notes (declared by a label-only line)
    var anchor = null;

    for (var i = 0; i < children.length; i++) {
      var el = children[i];

      if (el.tagName === 'TABLE') {
        var rows = parseTable(el);
        if (rows.length >= 2) {
          tiers = tiers.concat(rows);
          consumed.push(el);
          if (!anchor) anchor = el;
          open = null;
        }
        continue;
      }

      var segs = segmentsOf(el).filter(function (s) { return s.length; });
      if (!segs.length) { if (open) consumed.push(el); continue; }

      var used = 0;
      for (var j = 0; j < segs.length; j++) {
        var seg = segs[j];
        var m;

        if (PYRAMID_TITLE.test(seg)) { used++; continue; }

        if ((m = seg.match(LABEL_ONLY))) {
          open = { key: m[1].toLowerCase(), notes: [] };
          tiers.push(open);
          used++;
          continue;
        }

        if ((m = seg.match(LABEL_INLINE))) {
          var inline = splitNotes(m[2]);
          if (!inline) { open = null; break; }
          tiers.push({ key: m[1].toLowerCase(), notes: inline });
          /* The notes came with the label, so this tier is complete: anything
             that follows is prose, not more notes. */
          open = null;
          used++;
          continue;
        }

        if (open) {
          var notes = splitNotes(seg);
          if (!notes) { open = null; break; }
          open.notes = open.notes.concat(notes);
          used++;
          continue;
        }

        break; // outside the pyramid: leave the merchant's text alone
      }

      if (used > 0 && used === segs.length) {
        consumed.push(el);
        if (!anchor) anchor = el;
      } else if (used > 0) {
        return null; // half-consumed element: too risky to rewrite
      }
    }

    tiers = tiers.filter(function (t) { return t.notes.length; });
    if (tiers.length < 2 || !anchor) return null;
    for (var k = 0; k < tiers.length; k++) {
      if (TIERS.indexOf(tiers[k].key) === -1) return null;
    }
    return { tiers: tiers, consumed: consumed, anchor: anchor };
  }

  function build(tiers) {
    var wrap = document.createElement('div');
    wrap.className = 'rp-pyramid';
    var title = document.createElement('p');
    title.className = 'rp-pyramid__title';
    title.textContent = 'Piramide olfattiva';
    wrap.appendChild(title);
    var grid = document.createElement('div');
    grid.className = 'rp-pyramid__grid';
    tiers.forEach(function (t, index) {
      var tier = document.createElement('div');
      tier.className = 'rp-pyramid__tier';
      tier.setAttribute('data-tier', t.key);
      var h = document.createElement('p');
      h.className = 'rp-pyramid__tier-name';
      h.innerHTML = '<span class="rp-pyramid__step">' + (index + 1) + '</span>' +
                    '<span>Note di ' + t.key + '</span>';
      var ul = document.createElement('ul');
      ul.className = 'rp-pyramid__notes';
      t.notes.forEach(function (n) {
        var li = document.createElement('li');
        li.textContent = n.charAt(0).toUpperCase() + n.slice(1);
        ul.appendChild(li);
      });
      tier.appendChild(h);
      tier.appendChild(ul);
      grid.appendChild(tier);
    });
    wrap.appendChild(grid);
    return wrap;
  }

  function enhance(root) {
    if (!root || root.dataset.rpPyramid) return;
    root.dataset.rpPyramid = 'checked';
    var parsed;
    try { parsed = parse(root); } catch (e) { return; }
    if (!parsed) return;
    var node = build(parsed.tiers);
    if (!parsed.anchor || !parsed.anchor.parentNode) return;
    parsed.anchor.parentNode.insertBefore(node, parsed.anchor);
    parsed.consumed.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
  }

  function run(scope) {
    (scope || document).querySelectorAll('.rp-product-description').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  /* The info column is re-rendered when a variant changes. */
  var observer = new MutationObserver(function (mutations) {
    var needs = false;
    mutations.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType === 1 && (n.matches && n.matches('.rp-product-description') ||
            n.querySelector && n.querySelector('.rp-product-description'))) needs = true;
      });
    });
    if (needs) { observer.disconnect(); run(); observe(); }
  });
  function observe() {
    var section = document.querySelector('.shopify-section--main-product');
    if (section) observer.observe(section, { childList: true, subtree: true });
  }
  observe();
})();
